// this file is shared frontend and backend by a symlink
export const AUPRED_PROMPT_FUNC = (botName) => `📷` // gpt recommends non-empty to avoid llm repetition
